/**
 * tm/stepOwner.ts — 단계 「누가 할 일」 (2026-10-28 지도사 「하드코딩 하지는 말지 · 내가 각 단계에 뭐라고 안내할지 입력」)
 *  서버 services/stepOwner.js OWNERS 와 같은 열쇠 · 단계가 지금 단계가 되면 대표님 · 팀장님 몫은 「답 기다림」으로 열리고 안내 글 · 받을 서류가 나간다
 */
export type Owner = 'jido' | 'ceo' | 'fp' | 'both';
export const OWNERS: { v: Owner; label: string }[] = [
  { v: 'jido', label: '임지도사' },
  { v: 'ceo', label: '대표님' },
  { v: 'fp', label: '팀장님' },
  { v: 'both', label: '대표님 · 팀장님' },
];
export const ownerOf = (v: unknown): Owner => (v === 'ceo' || v === 'fp' || v === 'both' ? v : 'jido');
export const ownerLabel = (v: unknown): string => (OWNERS.find(o => o.v === ownerOf(v)) || OWNERS[0]).label;
/** 받을 서류 칸 — 쉼표 · 줄바꿈으로 나눠 중복 없이 */
export function splitItems(text: string): string[] {
  const list = text.split(/[,\n]/).map(x => x.trim()).filter(Boolean);
  return list.filter((x, i) => list.indexOf(x) === i).slice(0, 20);
}
